/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_MatterportInputs */

const cs_enum_matterport = /** @type {(inputs: Enum_MatterportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matterport`)
};

const en_enum_matterport = /** @type {(inputs: Enum_MatterportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matterport`)
};

/**
* | output |
* | --- |
* | "Matterport" |
*
* @param {Enum_MatterportInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_matterport = /** @type {((inputs?: Enum_MatterportInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_MatterportInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_matterport(inputs)
	return cs_enum_matterport(inputs)
});